import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { uncontrollable } from "uncontrollable";

import InputWrapper from "./styled";

/**
 * @deprecated use @streeteasy/design-system/form/TextInput instead
 */
export const Input = forwardRef(
  (
    {
      isDisabled,
      isInvalid,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      type,
      value,
      ...passThroughProps
    },
    ref
  ) => {
    const handleEvent = event => {
      const { value: eventValue } = event.target;

      switch (event.type) {
        case "change":
          onChange(eventValue, event);
          break;
        case "focus":
          onFocus(eventValue, event);
          break;
        case "blur":
          onBlur(eventValue, event);
          break;
        default:
        // nothing happens
      }
    };

    return (
      <InputWrapper
        ref={ref}
        isDisabled={isDisabled}
        isInvalid={isInvalid}
        onBlur={handleEvent}
        onChange={handleEvent}
        onFocus={handleEvent}
        placeholder={placeholder}
        type={type}
        value={value}
        {...passThroughProps}
      />
    );
  }
);

Input.displayName = "Input";

Input.propTypes = {
  /**
   * Enables disable state styling.
   */
  isDisabled: PropTypes.bool,
  /**
   * Enables error state styling.
   */
  isInvalid: PropTypes.bool,
  /**
   * Callback for when Input blurs.
   *
   * @param {string} value The input's value
   * @param {SyntheticEvent} event The react `SyntheticEvent`
   */
  onBlur: PropTypes.func,
  /**
   * Callback for when Input value changes.
   *
   * @param {string} value The input's value
   * @param {SyntheticEvent} event The react `SyntheticEvent`
   */
  onChange: PropTypes.func,
  /**
   * Callback for when Input is focused.
   *
   * @param {string} value The input's value
   * @param {SyntheticEvent} event The react `SyntheticEvent`
   */
  onFocus: PropTypes.func,
  /**
   * Input placeholder.
   */
  placeholder: PropTypes.string,
  /**
   * Input type.
   */
  type: PropTypes.string,
  /**
   * Input value.
   */
  value: PropTypes.string
};

Input.defaultProps = {
  isDisabled: false,
  isInvalid: false,
  onBlur: () => {},
  onChange: () => {},
  onFocus: () => {},
  placeholder: "",
  type: "text",
  value: ""
};

export default uncontrollable(Input, { value: "onChange" });
